import React from "react";
import { Phone } from "lucide-react";
import { SERVICES, COMPANY } from "../data/mock";
import { useRevealGroup } from "../hooks/useReveal";
import { PageHero, SectionHeading, ServiceCard, CTASection } from "../components/Shared";

export default function Services() {
  const ref = useRevealGroup();

  return (
    <div ref={ref}>
      <PageHero
        badge="Our Services"
        title="Reliable Insurance, Anytime, Anywhere"
        subtitle="What type of insurance do you require? Here's a closer look at what our insurance agents can provide and why you might need it."
        image="https://images.unsplash.com/photo-1475503572774-15a45e5d60b9?q=80&w=1600"
      />

      <section className="bg-[#F4F7FB] py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading
            badge="What We Offer"
            title={<>Coverage For Every <span className="text-[#0785C7]">Stage of Life</span></>}
            subtitle="If you were born in Canada, if you're new to the country, or if you're just visiting — we can help you find the right coverage for the right price."
          />
          <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <ServiceCard key={s.slug} service={s} index={i} />
            ))}
            <div data-reveal style={{ transitionDelay: "400ms" }} className="flex flex-col justify-center rounded-2xl border-2 border-dashed border-[#C7DEEB] p-8 text-center">
              <p className="font-heading text-xl font-bold text-[#0B2748]">Not sure which type of insurance you require?</p>
              <p className="mt-3 text-sm leading-relaxed text-[#526A7D]">Give us a call today for a free consultation. We're available 7 days a week.</p>
              <a href={COMPANY.phoneHref} className="btn-primary group mx-auto mt-6" data-testid="services-call-btn">
                <Phone className="h-4 w-4" /> {COMPANY.phone}
              </a>
            </div>
          </div>
        </div>
      </section>

      <CTASection title="Get Matched With the Right Policy Today" />
    </div>
  );
}
